import { DRYER_INFO } from './dryer';
import { ACCESSORY_INFO } from './accessory';
import { ACCESSORIES, DRYER } from '../laundry';

export const DRAWER_INFO = {
  [DRYER]: DRYER_INFO,
  [ACCESSORIES]: ACCESSORY_INFO
};